import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { AppstoreOutlined, FontSizeOutlined, LockOutlined, PictureOutlined,
  BgColorsOutlined, OrderedListOutlined, HighlightOutlined } from '@ant-design/icons';
import { TGDTool } from '../../../models/courses/graphicDesign';

const items = [
  { id: 'shape', icon: <AppstoreOutlined /> },
  { id: 'pictogram', icon: <PictureOutlined /> },
  { id: 'text', icon: <FontSizeOutlined /> },
  { id: 'palette', icon: <BgColorsOutlined /> },
  { id: 'layers', icon: <OrderedListOutlined /> },
  { id: 'gradient', icon: <HighlightOutlined /> },
] as const;

interface GDToolRailProps {
  active: TGDTool | null; allowedTools: TGDTool[];
  onChoose: (tool: TGDTool) => void;
}

const GDToolRail: React.FC<GDToolRailProps> = ({ active, allowedTools, onChoose }) => {
  const { t } = useTranslation();
  return <nav className="gd-rail" aria-label={t('graphicDesignLesson.editor.tools')}>
    {items.map(item => {
      const locked = item.id === 'gradient' || !allowedTools.includes(item.id);
      const label = t(`graphicDesignLesson.editor.tool.${item.id}`);
      return <Tooltip key={item.id} title={locked
        ? t(`graphicDesignLesson.editor.${item.id === 'gradient' ? 'comingSoon' : 'lockedTool'}`)
        : label}>
        <Button className="gd-rail-item" type={active === item.id ? 'primary' : 'text'}
          disabled={locked} aria-label={label} aria-pressed={active === item.id}
          onClick={() => onChoose(item.id)}>
          {item.icon}<span>{label}</span>{locked && <LockOutlined />}
        </Button>
      </Tooltip>;
    })}
  </nav>;
};

export default GDToolRail;
